const ZARbpayOptions = [
    {value: "ABSA", label: "Absa"},
    {value: "NEDBANK", label: "NedBank"},
    {value: "CAPITEC", label: "Capitec"},
    {value: "STANDARD", label: "Standard"},
    {value: "FNBANK", label: "Fnb"},
    {value: "AFRICANB", label: "African Bank"},
    {value: "BIDVESTB", label: "Bidvest Bank"},
    {value: "DISCOVERY", label: "Discovery"},
    {value: "FIRSTRANDB", label: "FirstRand Bank"},
    {value: "GRIDRODB", label: "Grindrod Bank"},
    {value: "IMPERIALB", label: "Imperial Bank"},
    {value: "INVESTECB", label: "Investec Bank"},
    {value: "SASFINB", label: "Sasfin Bank"},
    {value: "UBANK", label: "Ubank"},
    {value: "TYMEBANK", label: "TymeBank"},
    {value: "MERBANK", label: "Mercantile Bank"},
    {value: "ALBARAKA", label: "Albaraka Bank"},
    {value: "HBZBANK", label: "HBZ Bank"},
    {value: "HABIBO", label: "Habib Overseas Bank"},
    {value: "WESBANK", label: "Wesbank"},
    {value: "RANDMER", label: "Rand Merchant Bank"},
    {value: "BOATHENS", label: "Bank of Athens"},
];

export default ZARbpayOptions;
